import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont/iconfont.css';
import './styles/reset.css';

Vue.use(ElementUI);
Vue.config.productionTip = false;

/**
 * 全局请求方法
 */
import { get, post, uploadfile, remove, put } from './utils/request'
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$remove = remove
Vue.prototype.$put = put
Vue.prototype.$uploadfile = uploadfile

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

